import React from 'react';

export default function Footer() {
  return (
    <footer className="px-4 md:px-6 pt-6 md:pt-8 pb-8">
      <div className="max-w-7xl mx-auto bg-white rounded-[32px] md:rounded-[40px] px-6 md:px-12 py-14 border border-neutral-200">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="flex items-center gap-2.5">
              <img
                src="/one-catalyst-logo.png"
                alt="One Catalyst"
                className="h-9 w-9 rounded-[9px] object-contain"
              />
              <span className="font-display-bold text-[19px] tracking-tight text-neutral-900">One Catalyst</span>
            </div>
            <p className="mt-5 text-sm text-neutral-600 max-w-xl leading-relaxed">
              One Catalyst is a trusted partner for private clients and business families across capital, government, land and special situations.
            </p>
          </div>

          <div className="md:col-span-5">
            <div className="text-[11px] font-semibold uppercase tracking-widest text-neutral-500">Office address</div>
            <p className="mt-4 text-sm text-neutral-600 leading-relaxed">
              WeWork, Salarpuria Symbiosis, Arekere Village, Bannerghatta Rd, Begur Hobli, Bengaluru, Karnataka 560076
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-neutral-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-neutral-500">© {new Date().getFullYear()} One Catalyst. All rights reserved.</div>
          <div className="text-xs text-neutral-500">Your Partner for Complex Matters</div>
        </div>
      </div>
    </footer>
  );
}
